import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "../../../../pipes/pipes.module";
import { RegisterOwnerCodeFormComponent } from "./register-owner-code-form.component";

@NgModule({
    declarations: [RegisterOwnerCodeFormComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        PipesModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        MatProgressSpinnerModule
    ],
    exports: [RegisterOwnerCodeFormComponent]
})
export class RegisterOwnerCodeFormModule {}
